import { Toaster } from 'react-hot-toast';
import { config } from "../../config";

const NotificationBar = () => {
    return (
        <Toaster position={ config.notificationPosition } reverseOrder={false} />
    )
}

export default NotificationBar;